import { Component, OnInit } from "@angular/core";
import { Location } from "@angular/common";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "../auth.service";
import { DataServiceService } from "../data-service.service";
import { Search } from "../model/search";
import { getAdverseMediaTotalReturnedCount } from "../utils/adverse-media-utils";
import { clearHistoryDetailNavigation } from "../utils/history-navigation-utils";

@Component({
  selector: "app-search-list",
  templateUrl: "./search-list.component.html",
  styleUrls: ["./search-list.component.scss"],
})
export class SearchListComponent implements OnInit {
  isAllDBSearch =
    localStorage.getItem("isAllDBSearch") == "true" ? true : false;
  isPepSearch = localStorage.getItem("isPepSearch") == "true" ? true : false;
  isHongKongSearch =
    localStorage.getItem("isHongKongSearch") == "true" ? true : false;
  isInternationalSearch =
    localStorage.getItem("isInternationalSearch") == "true" ? true : false;
  isAdverseMediaSearch =
    localStorage.getItem("isAdverseMediaSearch") == "true";
  isIndividualSearch =
    localStorage.getItem("isIndividualSearch") == "true" ? true : false;
  isChineseSearch =
    localStorage.getItem("isChineseSearch") == "true" ? true : false;
  search: Search = new Search();
  searchTerm = "";
  searchResult: any;
  sanctionSearchResult: any;
  criminalsSearchResult: any;
  nslSearchResult: any;
  entitySearchResult: any;
  nslEntitySearchResult: any;
  adverseMediaSearchResult: any;
  adverseMediaReturnedHitCount = 0;
  isLoading: boolean = true;
  searchedName = "";
  entityDD = "00";
  entityMM = "00";
  entityYYYY = "0000";
  entityGender = "NO";
  dailyCounter;
  typeOfSearch = localStorage.getItem("searchType");

  constructor(
    private router: Router,
    private dataService: DataServiceService,
    private route: ActivatedRoute,
    private location: Location,
    private authService: AuthService
  ) {}

  goBack() {
    this.location.back();
  }

  async ngOnInit() {
    if (this.authService.getCurrentUser()?.isAdverseMediaEnabled !== true) {
      this.isAdverseMediaSearch = false;
    }

    const skipOnBack = localStorage.getItem("skipSearchOnBack") === "true";
    const skipOnBackTs = Number(
      localStorage.getItem("skipSearchOnBackTs") || "0",
    );
    const skipOnBackValid = skipOnBack && Date.now() - skipOnBackTs < 60000;
    if (skipOnBack && !skipOnBackValid) {
      localStorage.removeItem("skipSearchOnBack");
      localStorage.removeItem("skipSearchOnBackTs");
    }

    this.searchedName = this.route.snapshot.params.name
      ? this.route.snapshot.params.name
      : "";
    this.search.englishName = this.searchedName;
    if (this.searchedName == "") {
      this.router.navigate(["/search"]);
    }

    if (skipOnBackValid) {
      // When returning from a result page, we should avoid consuming credits
      // by skipping the search APIs and restoring cached results instead.
      localStorage.removeItem("skipSearchOnBack");
      localStorage.removeItem("skipSearchOnBackTs");
      if (this.isIndividualSearch) {
        this.searchResult = localStorage.getItem("pepSearchResult")
          ? JSON.parse(localStorage.getItem("pepSearchResult") || "null")
          : null;
        this.nslSearchResult = localStorage.getItem("nslSearchResult")
          ? JSON.parse(localStorage.getItem("nslSearchResult") || "null")
          : null;
        this.sanctionSearchResult = localStorage.getItem("sanctionSearchResult")
          ? JSON.parse(localStorage.getItem("sanctionSearchResult") || "null")
          : null;
        this.criminalsSearchResult = localStorage.getItem(
          "criminalsSearchResult",
        )
          ? JSON.parse(localStorage.getItem("criminalsSearchResult") || "null")
          : null;
        this.adverseMediaSearchResult = localStorage.getItem(
          "adverseMediaSearchResult",
        )
          ? JSON.parse(
              localStorage.getItem("adverseMediaSearchResult") || "null",
            )
          : null;
      } else {
        this.entitySearchResult = localStorage.getItem("entitySearchResult")
          ? JSON.parse(localStorage.getItem("entitySearchResult") || "null")
          : null;
        this.nslEntitySearchResult = localStorage.getItem(
          "nslEntitySearchResult",
        )
          ? JSON.parse(localStorage.getItem("nslEntitySearchResult") || "null")
          : null;
        this.adverseMediaSearchResult = localStorage.getItem(
          "adverseMediaSearchResult",
        )
          ? JSON.parse(
              localStorage.getItem("adverseMediaSearchResult") || "null",
            )
          : null;
      }

      this.syncAdverseMediaReturnedHitCount();

      const cachedDaily = localStorage.getItem("dailyCounter");
      if (cachedDaily) this.dailyCounter = cachedDaily;

      this.isLoading = false;
      return;
    }

    if (this.isIndividualSearch) {
      if (this.typeOfSearch == "advance") {
        this.getDataFromLocalStorage();
        const searches: Promise<void>[] = [
          this.getAdvanceSearch(),
          this.getNSLAdvanceSearch(),
        ];
        if (this.isAdverseMediaSearch) {
          searches.push(this.getAdverseMediaSearch());
        }
        Promise.all(searches)
          .then(() => {
            this.isLoading = false;
            this.consumeSearchCredits();
          })
          .catch((err) => {
            this.isLoading = false;
          });
      } else {
        const searches: Promise<void>[] = [
          this.getQuickSearch(),
          this.getNSLQuickSearch(),
        ];
        if (this.isAdverseMediaSearch) {
          searches.push(this.getAdverseMediaSearch());
        }
        Promise.all(searches)
          .then(() => {
            this.isLoading = false;
            this.consumeSearchCredits();
          })
          .catch((err) => {
            this.isLoading = false;
          });
      }
    } else {
      this.searchedName = this.route.snapshot.params.name
        ? this.route.snapshot.params.name
        : "";
      this.search.englishName = this.searchedName;
      const searches: Promise<void>[] = [
        this.getEntityQuickSearch(),
        this.getNSLEntityQuickSearch(),
      ];
      if (this.isAdverseMediaSearch) {
        searches.push(this.getAdverseMediaSearch());
      }
      Promise.all(searches)
        .then(() => {
          this.isLoading = false;
          this.consumeSearchCredits();
        })
        .catch((err) => {
          this.isLoading = false;
        });
    }
  }

  consumeSearchCredits() {
    const count = this.isAdverseMediaSearch ? 2 : 1;
    this.dataService
      .increaseSearchCredit(count)
      .then(() => {
        this.dataService
          .incrementDailyCounter()
          .then((response) => {
            this.dailyCounter = response.daily_counter;
            localStorage.setItem("dailyCounter", this.dailyCounter);
            console.log("Daily counter:", this.dailyCounter);
          })
          .catch((err) =>
            console.error("Error incrementing daily counter:", err),
          );
      })
      .catch((err) =>
        console.error("Error increasing search credit:", err),
      );
  }

  printPage() {
    localStorage.setItem("searchedName", this.searchedName);
    if (this.isIndividualSearch) {
      localStorage.setItem(
        "pepSearchResult",
        JSON.stringify(this.searchResult),
      );
      localStorage.setItem(
        "nslSearchResult",
        JSON.stringify(this.nslSearchResult),
      );
      localStorage.setItem(
        "sanctionSearchResult",
        JSON.stringify(this.sanctionSearchResult),
      );
      localStorage.setItem(
        "criminalsSearchResult",
        JSON.stringify(this.criminalsSearchResult),
      );
      localStorage.setItem(
        "adverseMediaSearchResult",
        JSON.stringify(this.adverseMediaSearchResult),
      );
    } else {
      localStorage.setItem(
        "entitySearchResult",
        JSON.stringify(this.entitySearchResult),
      );
      localStorage.setItem(
        "nslEntitySearchResult",
        JSON.stringify(this.nslEntitySearchResult),
      );
      localStorage.setItem(
        "adverseMediaSearchResult",
        JSON.stringify(this.adverseMediaSearchResult),
      );
    }
    this.router.navigate([`/new-print`]); // TODO: change to print || new-print
  }

  async getQuickSearch() {
    try {
      this.searchResult = await this.dataService.getQuickSearch({
        name: this.searchedName,
        isChinese: this.isChineseSearch,
      });
      // console.log(this.searchResult);
      this.criminalsSearchResult = this.searchResult.found_records.filter(
        (result) => result["source_type"] == "CRIMINAL",
      );
      this.sanctionSearchResult = this.searchResult.found_records.filter(
        (result) =>
          (result["source_type"] == "SANCTION" &&
            result["entity_type"] == "INDIVIDUAL") ||
          (result["source_type"] == "SANCTION" &&
            result["entity_type"] == "UNKNOWN"),
      );
      this.searchResult = this.searchResult.found_records.filter(
        (result) =>
          !result["source_type"] ||
          result["source_type"] == "" ||
          result["source_type"] == "PEP",
      );
    } catch (e) {
      this.searchResult = null;
    }
  }

  async getEntityQuickSearch() {
    try {
      this.entitySearchResult = await this.dataService.getEntityQuickSearch({
        name: this.searchedName,
      });
    } catch (e) {
      this.entitySearchResult = null;
    }
  }

  async getNSLEntityQuickSearch() {
    try {
      this.nslEntitySearchResult =
        await this.dataService.getNSLEntityQuickSearch({
          name: this.searchedName,
          isChinese: this.isChineseSearch,
        });
    } catch (e) {
      this.nslEntitySearchResult = null;
    }
  }

  async getNSLQuickSearch() {
    try {
      this.nslSearchResult = await this.dataService.getNSLQuickSearch({
        name: this.searchedName,
        isChinese: this.isChineseSearch,
      });
    } catch (e) {
      this.nslSearchResult = null;
    }
  }

  async getAdvanceSearch() {
    // console.log(this.search)
    this.search["isChinese"] = this.isChineseSearch;
    try {
      this.searchResult = await this.dataService
        .getAdvanceSearch(this.search)
        .catch((err) => {
          this.searchResult = null;
        });
      this.criminalsSearchResult = this.searchResult.found_records.filter(
        (result) => result["source_type"] == "CRIMINAL",
      );
      this.sanctionSearchResult = this.searchResult.found_records.filter(
        (result) =>
          (result["source_type"] == "SANCTION" &&
            result["entity_type"] == "INDIVIDUAL") ||
          (result["source_type"] == "SANCTION" &&
            result["entity_type"] == "UNKNOWN"),
      );
      this.searchResult = this.searchResult.found_records.filter(
        (result) =>
          !result["source_type"] ||
          result["source_type"] == "" ||
          result["source_type"] == "PEP",
      );
    } catch (err) {
      this.sanctionSearchResult = null;
      this.searchResult = null;
    }
  }

  async getNSLAdvanceSearch() {
    // console.log(this.search)
    this.search["isChinese"] = this.isChineseSearch;
    this.nslSearchResult = await this.dataService
      .getNSLAdvanceSearch(this.search)
      .catch((err) => {
        this.nslSearchResult = null;
      });
  }

  async getAdverseMediaSearch() {
    try {
      this.adverseMediaSearchResult =
        await this.dataService.getAdverseMediaSearch({
          name: this.searchedName,
          fetch_articles: true,
          isEntity: !this.isIndividualSearch,
        });
    } catch (e) {
      this.adverseMediaSearchResult = null;
    } finally {
      this.syncAdverseMediaReturnedHitCount();
    }
  }

  private syncAdverseMediaReturnedHitCount() {
    const result = this.adverseMediaSearchResult;
    if (!result) {
      this.adverseMediaReturnedHitCount = 0;
      return;
    }

    if (typeof result.returned_article_count === "number") {
      this.adverseMediaReturnedHitCount = result.returned_article_count;
      return;
    }

    this.adverseMediaReturnedHitCount =
      getAdverseMediaTotalReturnedCount(result);
  }

  showAdverseMediaDetails() {
    this.cacheSearchResultsForBack();
    clearHistoryDetailNavigation();
    localStorage.setItem(
      "adverseMediaData",
      JSON.stringify(this.adverseMediaSearchResult),
    );
    localStorage.setItem("adverseMediaSearchedName", this.searchedName);
    this.router.navigate(["/result-adverse-media"]);
  }

  getAdverseMediaHitCount(result: any = this.adverseMediaSearchResult): number {
    if (result === this.adverseMediaSearchResult) {
      return this.adverseMediaReturnedHitCount;
    }
    return getAdverseMediaTotalReturnedCount(result);
  }

  showCriminalDetails(data) {
    this.cacheSearchResultsForBack();
    localStorage.setItem("data", JSON.stringify(data));
    this.router.navigate(["/result-criminal"]);
  }

  showPEPDetails(data) {
    this.cacheSearchResultsForBack();
    localStorage.setItem("data", JSON.stringify(data));
    this.router.navigate(["/result"]);
  }

  showSanctionsDetails(data) {
    this.cacheSearchResultsForBack();
    localStorage.setItem("data", JSON.stringify(data));
    this.router.navigate(["/result-sanction"]);
  }

  showNSLDetails(data) {
    this.cacheSearchResultsForBack();
    localStorage.setItem("data", JSON.stringify(data));
    this.router.navigate(["/result-nsl"]);
  }

  showEntityDetails(data) {
    this.cacheSearchResultsForBack();
    localStorage.setItem("data", JSON.stringify(data));
    this.router.navigate(["/result-entity"]);
  }

  showNSLEntityDetails(data) {
    this.cacheSearchResultsForBack();
    localStorage.setItem("data", JSON.stringify(data));
    this.router.navigate(["/result-nsl-entity"]);
  }

  private cacheSearchResultsForBack() {
    // Cache current list results so SearchListComponent can restore them
    // without calling search APIs when the user navigates back.
    if (this.isIndividualSearch) {
      localStorage.setItem(
        "pepSearchResult",
        JSON.stringify(this.searchResult),
      );
      localStorage.setItem(
        "nslSearchResult",
        JSON.stringify(this.nslSearchResult),
      );
      localStorage.setItem(
        "sanctionSearchResult",
        JSON.stringify(this.sanctionSearchResult),
      );
      localStorage.setItem(
        "criminalsSearchResult",
        JSON.stringify(this.criminalsSearchResult),
      );
      localStorage.setItem(
        "adverseMediaSearchResult",
        JSON.stringify(this.adverseMediaSearchResult),
      );
    } else {
      localStorage.setItem(
        "entitySearchResult",
        JSON.stringify(this.entitySearchResult),
      );
      localStorage.setItem(
        "nslEntitySearchResult",
        JSON.stringify(this.nslEntitySearchResult),
      );
      localStorage.setItem(
        "adverseMediaSearchResult",
        JSON.stringify(this.adverseMediaSearchResult),
      );
    }
  }

  getDataFromLocalStorage() {
    this.entityDD = localStorage.getItem("dd")
      ? localStorage.getItem("dd")
      : "00";
    this.entityMM = localStorage.getItem("mm")
      ? localStorage.getItem("mm")
      : "00";
    this.entityYYYY = localStorage.getItem("yyyy")
      ? localStorage.getItem("yyyy")
      : "0000";
    this.entityGender = localStorage.getItem("gender")
      ? localStorage.getItem("gender")
      : "NO";
    this.search.dd = this.entityDD;
    this.search.mm = this.entityMM;
    this.search.yyyy = this.entityYYYY;
    this.search.gender = this.entityGender;
  }
}
